import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card";
import { Icon } from "@iconify-icon/solid";
import { LoadingButton } from "../../components/ui/Button";
import useCheckupComplaint from "../../services/checkup/useCheckupComplaint";
import { onMount, For, Show, createEffect } from "solid-js";
import { Button } from "@/components/shadcn/button";
import { Checkbox, CheckboxControl, CheckboxLabel } from "@/components/shadcn/checkbox";

export default function CheckupComplaint(props) {

  const { complaints, complaintForm, onSaveComplaint, onFetchComplaints, addComplaint, removeComplaint } = useCheckupComplaint(props);

  onMount(() => {
    onFetchComplaints();
    // Register save function with parent component
    if (props.onRegisterSave) {
      props.onRegisterSave(onSaveComplaint);
    }
  });

  const handleComplaintToggle = (complaintId, complaintName) => {
    const existingIndex = complaintForm.complaints.findIndex(complaint => complaint.complaintId === complaintId);
    
    if (existingIndex > -1) {
      // Remove complaint if it exists
      removeComplaint(complaintForm.complaints[existingIndex].key);
    } else {
      // Add complaint if it doesn't exist
      const newComplaint = {
        key: crypto.randomUUID(),
        uid: null,
        complaintId: complaintId,
        name: complaintName,
      };
      addComplaint(newComplaint);
    }
  };

  const isComplaintSelected = (complaintId) => {
    return complaintForm.complaints.some(complaint => complaint.complaintId === complaintId);
  };

  // Track form changes - compare with original complaints
  createEffect(() => {
    if (props.onFormChange) {
      const originalComplaints = props.complaints || [];
      const currentComplaints = complaintForm.complaints || [];
      
      // Compare complaint IDs to see if selection changed
      const originalIds = originalComplaints.map(c => c.complaintId).sort();
      const currentIds = currentComplaints.map(c => c.complaintId).sort();
      
      const hasChanges = JSON.stringify(originalIds) !== JSON.stringify(currentIds);
      props.onFormChange(hasChanges);
    }
  });

  const content = (
    <>
      <Show when={!props.hideCard}>
        <CardHeader>
          <CardTitle class="flex items-center gap-2">
            <Icon icon="mdi:stethoscope" class="text-gray-500 me-2" />
            Complaints
          </CardTitle>
        </CardHeader>
      </Show>
      <div class={props.hideCard ? "space-y-4" : ""}>
        {/* Available Complaints */}
        <div class="pt-0">
          <h4 class="font-medium text-gray-900 mb-3 dark:text-gray-100">
            Available Complaints
          </h4>
          <div class="grid grid-cols-2 gap-2 max-h-80 overflow-y-auto">
            <For each={complaints()}>
              {(complaint) => (
                <Checkbox
                  checked={isComplaintSelected(complaint.value)}
                  onChange={() => handleComplaintToggle(complaint.value, complaint.text)}
                  class="flex items-center space-x-1 p-1 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <CheckboxControl />
                  <CheckboxLabel class="ms-1 text-sm font-medium text-gray-700 dark:text-gray-300">
                    {complaint.text}
                  </CheckboxLabel>
                </Checkbox>
              )}
            </For>
          </div>
        </div>

        {/* Save Button */}
        <Show when={!props.hideSaveButton}>
          <div class="border-t pt-4">
            <LoadingButton
              loading={props.loading}
              onClick={onSaveComplaint}
              disabled={!complaintForm.complaints || complaintForm.complaints.length === 0}
            >
              Save Complaints
            </LoadingButton>
          </div>
        </Show>
      </div>
    </>
  );

  return (
    <Show when={props.hideCard} fallback={<Card><CardContent class="space-y-4">{content}</CardContent></Card>}>
      {content}
    </Show>
  );
}
